import type { LinkType } from '@/components/AuthV2/InfoGraphics';
import { FOOTER_LINKS } from '@/components/AuthV2/InfoGraphics';

import { FooterLink } from './FooterLink';

export const FooterSection = ({ type }: FooterSectionProps) => {
  return (
    <div className='flex flex-col'>
      <div className='flex gap-2'>
        {FOOTER_LINKS[type].map((link, index) => (
          <FooterLink key={index} {...link} />
        ))}
      </div>
    </div>
  );
};

type FooterSectionProps = {
  type: LinkType;
};
